module.exports = __webpack_public_path__ + "static/media/LibreBaskerville-Regular.27b9efe7.ttf";